module.exports = __webpack_public_path__ + "img/22_72.739ac7ce.png";